import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../services/apiClient";
import {
  GetCommunicationByExternalId,
} from "../../config/config";

export const GetcommunicationDetail = createAsyncThunk(
  "communication/GetcommunicationDetail",
  async (ParamObject: any, { rejectWithValue }) => {
    try {

      const externalID = ParamObject.externalID;

      const response = await apiClient.get(
        GetCommunicationByExternalId,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            ExternalId: externalID,
            'mode': "outlook",
          },
        }
      );
      return response ? response.data : null;
    } catch (error) {
      return rejectWithValue(error.response); // Return error message
    }
  }
);

const communicationDetailSlice = createSlice({
  name: "communicationDetail",
  initialState: {
    communicationDetail: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetcommunicationDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetcommunicationDetail.fulfilled, (state, action) => {

        state.loading = false;
        state.communicationDetail = action.payload;
      })
      .addCase(GetcommunicationDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default communicationDetailSlice.reducer;
